import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'searchable-dropdown',
  templateUrl: './searchable-dropdown.component.html'
})
export class SearchableDropdownComponent implements OnInit, OnChanges {

  @Input() dropdownData: any;
  @Output() selectedDropDowns: EventEmitter<any> = new EventEmitter();

  public selectedValues: [];
  constructor() { }

  ngOnInit() {
    this.applyInitialSelectionFromDropdownData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dropdownData) {
      this.applyInitialSelectionFromDropdownData();
    }
  }

  private applyInitialSelectionFromDropdownData() {
    const init = this.dropdownData && this.dropdownData.initialSelected;
    if (init && Array.isArray(init) && init.length > 0) {
      this.selectedValues = init.slice() as any;
    }
  }

  chosenOptions() {
    const emitSelections = {
      [this.dropdownData.key]: this.selectedValues
    };
    this.selectedDropDowns.emit(emitSelections);
  }
}
